export default "__VITE_ASSET__Cu62EhnW__"